import site from './site.json';

const origin = site.origin.replace(/\/$/, '');

function canonicalUrl(path) {
  const clean = path === '/' ? '/' : path.replace(/\/$/, '');
  return origin + clean;
}

function upsert(selector, create, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(...value);
}

function meta(attr, key, content) {
  upsert(`meta[${attr}="${key}"]`, () => {
    const el = document.createElement('meta');
    el.setAttribute(attr, key);
    return el;
  }, ['content', content]);
}

export function routeMeta(path) {
  return site.routes[path === '/' ? '/' : path.replace(/\/$/, '')] || {};
}

/**
 * Keeps the head in sync on client-side navigation. Flask injects the same tags
 * server-side for crawlers; this updates them in place rather than duplicating.
 */
export function applyMeta({ path, title, description, image } = {}) {
  const route = routeMeta(path || '/');
  const resolved = {
    title: title || route.title || site.defaultTitle,
    description: description || route.description || site.defaultDescription,
    url: canonicalUrl(path || '/'),
    image: origin + (image || site.logo),
  };

  document.title = resolved.title;
  meta('name', 'description', resolved.description);
  upsert('link[rel="canonical"]', () => {
    const el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    return el;
  }, ['href', resolved.url]);

  meta('property', 'og:title', resolved.title);
  meta('property', 'og:description', resolved.description);
  meta('property', 'og:url', resolved.url);
  meta('property', 'og:image', resolved.image);
  meta('property', 'og:type', 'website');
  meta('property', 'og:site_name', site.name);
  meta('name', 'twitter:card', 'summary_large_image');
  meta('name', 'twitter:title', resolved.title);
  meta('name', 'twitter:description', resolved.description);
  meta('name', 'twitter:image', resolved.image);
}

export default site;
